/**
 * Get the display image for a project based on preference with smart fallback
 * @param {Object} project - Project object
 * @returns {string} - URL of the image to display
 */
export function getProjectDisplayImage(project) {
  if (!project) return '';
  
  const preference = project.image_display_preference || 'thumbnail';
  
  // Try preferred image first
  if (preference === 'thumbnail' && project.thumbnail) {
    return project.thumbnail;
  }
  
  if (preference === 'poster' && project.poster) {
    return project.poster;
  }
  
  // Fallback to the other option
  if (preference === 'thumbnail' && project.poster) {
    return project.poster;
  }
  
  if (preference === 'poster' && project.thumbnail) {
    return project.thumbnail;
  }
  
  // Final fallback chain
  return project.thumbnail || project.poster || project.hero_image || '';
}

/**
 * Get the aspect ratio class based on which image is being displayed
 * @param {Object} project - Project object
 * @returns {string} - Aspect ratio class (aspect-[2/3] or aspect-video)
 */
export function getProjectAspectRatio(project) {
  if (!project) return 'aspect-[2/3]';
  
  const preference = project.image_display_preference || 'thumbnail';
  
  // If preference is poster and poster exists, use vertical ratio
  if (preference === 'poster' && project.poster) {
    return 'aspect-[2/3]';
  }
  
  // If preference is thumbnail and thumbnail exists, use horizontal ratio
  if (preference === 'thumbnail' && project.thumbnail) {
    return 'aspect-video';
  }
  
  // Fallback logic - check which image actually exists
  if (preference === 'thumbnail' && project.poster) {
    return 'aspect-[2/3]'; // Using poster as fallback
  }
  
  if (preference === 'poster' && project.thumbnail) {
    return 'aspect-video'; // Using thumbnail as fallback
  }
  
  // Default based on what's available
  if (project.poster) return 'aspect-[2/3]';
  if (project.thumbnail) return 'aspect-video';
  
  return 'aspect-[2/3]'; // Default
}
